import { HttpClient } from '@angular/common/http';
import { IdentifyFeatures } from 'esri-leaflet';
import * as L from 'leaflet';
import { VolcanoResultItem } from 'src/app/apiAndObjects/objects/resultItems/volcanoResultItem';
import {
  EsriDynamicLayer,
  FeatureDisplayItem,
  FeatureDisplayItemGenerator,
} from 'src/app/bgsLeaflet/public_api';

export class VolcanoMapLayer extends EsriDynamicLayer {
  constructor() {
    super('si_volcanoes', 'Volcanoes');
    this.options
      .set('url', 'https://map.bgs.ac.uk/arcgis/rest/services/SIV/SIV/MapServer')
      .options.set('layers', [0])
      .setFeatureIdentifiable(new MyFeatureIdentifier(this));
  }
}

class MyFeatureIdentifier implements FeatureDisplayItemGenerator {
  constructor(protected layer: EsriDynamicLayer) {}

  /* eslint-disable @typescript-eslint/no-unused-vars */
  public getFeatureDisplayItems(
    clickEvent: L.LeafletMouseEvent,
    http: HttpClient,
  ): Promise<Array<FeatureDisplayItem>> {
    return new Promise((resolve) => {
      new IdentifyFeatures({
        url: this.layer.options.get('url'),
      })
        .on(this.layer.getBgsLeaflet().leafletMapObj)
        .at([clickEvent.latlng.lat, clickEvent.latlng.lng])
        .layers('all:0')
        .tolerance(10)
        .run((error: any, featureCollection: GeoJSON.FeatureCollection) => {
          const resultItemPromises = featureCollection.features.map((element: GeoJSON.Feature) =>
            VolcanoResultItem.constructObject(element as unknown as Record<string, unknown>),
          );
          resolve(
            Promise.all(resultItemPromises).then((resultItems: Array<VolcanoResultItem>) =>
              resultItems.map((item) => new FeatureDisplayItem(item)),
            ),
          );
        });
    });
  }
}
